export default {
  API: process.env.VUE_APP_ENDPOINT,
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  IMAGE_PROXY: "https://images.weserv.nl/?url=",
  SYSTEM_CONFIG: {
    domain: 'https://kygui.diepanh_logistics.vn',
    firebase_prefix: 'diepanh_logistics',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o',
    quick_store_import: false,
    notification_time: 30,
    auto_pack_code: false,
    accountant_order_fee_column: false
  },
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["ID"]
  },
  ITEMS_PER_PAGE: {
    'items-per-page-options': [20, 30, 40, 50]
  },
  COLOR_CHART: {
    blue: '#4C84FF',
    blue_light: '#A9C4FF',
    red: '#0051a2',
    red_light: '#FE9FA5'
  },
  COMPARE_PERIOD: [
    'Previous period',
    'Previous month',
    'Previous year'
  ],

  VIP_LEVEL: [
    { value: 1, name: '', color: '' },
    { value: 2, name: 'v1', color: '#FFCC80' },
    { value: 3, name: 'v2', color: '#FFB74D' },
    { value: 4, name: 'v3', color: '#FFA726' },
    { value: 5, name: 'v4', color: '#FB8C00' },
    { value: 6, name: 'v5', color: '#F57C00' },
    { value: 7, name: 'v6', color: '#EF6C00' },
  ],

  PACKAGE_STATUS_ENUM: {
    DANG_VAN_CHUYEN: 0,
    DA_NHAP_KHO_TQ: 1,
    DA_DONG_BAO: 2,
    DA_NHAP_KHO_VN: 3,
    DA_GIAO_HANG: 4
  },
  PACKAGE_STATUS: [
    { value: 0, name: 'Đang vận chuyển', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 1, name: 'Đã nhập kho TQ', disabled: false, color: 'orange', textColor: '#FFF' },
    { value: 2, name: 'Đã đóng bao', disabled: false, color: 'blue', textColor: '#FFF' },
    { value: 3, name: 'Đã nhập kho VN', disabled: false, color: 'green', textColor: '#FFF' },
    { value: 4, name: 'Đã giao hàng', disabled: false, color: '#0051a2', textColor: '#FFF' },
  ],
  COMMENT_TYPE: [
    { value: 1, name: 'Công khai', color: '#2EBB32' },
    { value: 2, name: 'Nội bộ', color: '#0051a2' }
  ],
  LOCATION_STORE: [
    { value: 1, name: 'Kho Hà Nội', shortname: 'HN' },
    { value: 2, name: 'Thái Nguyên', shortname: 'TN' },
    { value: 3, name: 'Kho Hồ Chí Minh', shortname: 'HCM' },
  ],
  CUSTOMER_STATUS: {
    Actived: 1,
    Blocked: 2
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 2, name: 'Đang bị khóa', color: '#e63900' },
  ],
  RECHARGE_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
    Transferred: 4,
    Cash: 5,
  },
  RECHARGE_STATUS_LIST: [
    // { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
    { value: 2, name: 'Thành công', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy', color: '#e63900', textColor: '#000' },
    // { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
    // { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
  ],
  WITHDRAW_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
  },
  WITHDRAW_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#0051a2', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
  ],
  PAYMENT_TYPE: {
    Deposit: 1,
    Complete: 2,
  },
  PAYMENT_TYPE_LIST: [
    { value: 1, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 2, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  PAYMENT_STATUS_LIST: [
    { value: 2, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
    { value: 10, name: 'Phí ship', color: '#808080', textColor: '#FFF' },
    { value: 12, name: 'Nhận lại cọc', color: '#FFB74D', textColor: '#000' },
  ],
  COMPLAIN_STATUS: {
    Cancel: 0,
    Processing: 2,
    Pending: 1,
    Done: 3,
  },
  COMPLAIN_STATUS_LIST: [
    { value: 0, name: 'Hủy', color: 'orange' },
    { value: 2, name: 'Đang xử lý', color: 'green' },
    { value: 1, name: 'Chờ xử lý', color: 'red' },
    { value: 3, name: 'Đã xử lý', color: 'blue' }
  ],
  RECHARGE_TYPE: {
    Techcombank: 1,
    Vietcombank: 2,
    BIDV: 3,
    Cash: 4,
    COD: 5,
  },
  RECHARGE_METHODS: [
    { value: 1, name: 'Techcombank' },
    { value: 2, name: 'Vietcombank' },
    { value: 3, name: 'BIDV' },
    { value: 4, name: 'Cash' },
    { value: 5, name: 'COD' },
  ],
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0, i18n: 'comparison.contain' },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0, i18n: 'comparison.does_not_contain' },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0, i18n: 'comparison.s_equal' },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0, i18n: 'comparison.s_does_not_equal' },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1, i18n: 'comparison.equal' },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1, i18n: 'comparison.does_not_equal' },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1, i18n: 'comparison.greater_than' },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1, i18n: 'comparison.greater_than_or_equal' },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1, i18n: 'comparison.less_than' },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1, i18n: 'comparison.less_than_or_equal' },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2, i18n: 'comparison.in' },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2, i18n: 'comparison.not_in' },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3, i18n: 'comparison.d_equal' },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3, i18n: 'comparison.d_does_not_equal' },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3, i18n: 'comparison.d_greater_than' },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3, i18n: 'comparison.d_greater_than_or_equal' },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3, i18n: 'comparison.d_less_than' },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3, i18n: 'comparison.d_less_than_or_equal' },
  ],
  ROLE_TYPE: {
    Admin: 1,
    Sale: 2,
    Store: 4,
    Customer: 8,
    Accountant: 16,
    CustomerSupport: 32,
    StoreVN: 64,
    StoreManager: 128
  },
  ROLES: [
    { value: 1, name: 'Admin', modules: 6127 },
    { value: 2, name: 'Sale', modules: 5247 },
    { value: 4, name: 'Kho TQ', modules: 233 },
    { value: 8, name: 'Khách hàng', modules: 6201 },
    { value: 16, name: 'Kế toán', modules: 6127 },
    { value: 32, name: 'Điều vận', modules: 5247 },
    { value: 64, name: 'Kho VN', modules: 5247 },
    { value: 128, name: 'Chứng từ', modules: 5247 },
  ],
  TRADE_TYPE: [
    { value: 1, name: 'Đặt cọc' },
    { value: 2, name: 'Nhận lại tiền đặt cọc' },
    { value: 3, name: 'Thanh toán hóa đơn' },
    { value: 4, name: 'Nạp tiền' },
    { value: 5, name: 'Rút tiền' },
    { value: 6, name: 'Hủy lệnh rút tiền' },
    { value: 7, name: 'Xử lý khiếu nại' },
    { value: 8, name: 'Hủy lệnh chuyển tiền' },
  ],
  FEE_TYPE: {
    ByWeight: 0,
    ByVolume: 1
  },
  FEE_TYPES: [
    { value: 0, name: 'Theo cân' },
    { value: 1, name: 'Theo khối' }
  ],
  BIGPACKAGE_STATUS_TYPE: {
    Chua_thanh_toan: 0,
    Da_thanh_toan: 1
  },
  BIGPACKAGE_STATUS: [
    { value: 0, name: 'Chưa thanh toán', color: 'red' },
    { value: 1, name: 'Đã thanh toán', color: 'blue' }
  ],
  BIGPACKAGE_STATUS_ENUM: {
    da_dong_bao: 0,
    da_gui: 1,
    da_nhan: 2,
    da_thanh_toan: 3
  },
  BIGPACKAGE_STATUS_LIST: [
    { value: 0, name: 'Đã đóng bao', color: '#808080', textColor: '#FFF' },
    { value: 1, name: 'Đã xuất kho', color: '#0059b3', textColor: '#FFF' },
    { value: 2, name: 'Đã nhận', color: '#2d8659', textColor: '#FFF' },
    { value: 3, name: 'Đã thanh toán', color: '#FFB74D', textColor: '#000' }
  ],
  PRODUCT_TYPE: {
    Kuaidi: 1,
    Shipment: 2
  },
  PRODUCT_TYPE_LIST: [
    { value: 1, name: 'Kuaidi', color: '#000000' },
    { value: 2, name: 'Hàng lô', color: 'blue' }
  ],
  RECEIVE_TYPE: {
    cho_xep_xe: 0,
    xep_xe: 1,
    cho_thong_quan_tq: 2,
    kiem_hoa: 3,
    cho_thong_quan_vn: 4,
    nhap_kho_vn: 5
  },
  RECEIVE_TYPE_LIST: [
    { value: 0, name: 'Chờ xếp xe', color: '#b29703ff', i18n: 'receive_type.cho_xep_xe' },
    { value: 1, name: 'Xếp xe', color: 'black', i18n: 'receive_type.xep_xe' },
    // { value: 2, name: 'Chờ thông quan TQ', color: '#2d8659', i18n: 'receive_type.cho_thong_quan_tq' },
    { value: 3, name: 'Kiểm hóa', color: 'red', i18n: 'receive_type.kiem_hoa' },
    { value: 4, name: 'Chờ thông quan VN', color: '#0059b3', i18n: 'receive_type.cho_thong_quan_vn' },
    { value: 5, name: 'Nhập kho VN', color: '#048a45ff', i18n: 'receive_type.nhap_kho_vn' }
  ],
  PRODUCT_STATUS: {
    nhap_kho_tq: 1,
    cho_xep_xe: 2,
    xep_xe: 3,
    cho_thong_quan_tq: 4,
    kiem_hoa: 5,
    cho_thong_quan_vn: 6,
    nhap_kho_vn: 7,
    xuat_thieu: 8,
    xuat_du: 9
  },
  PRODUCT_STATUS_LIST: [
    { value: 1, name: 'Nhập kho TQ', color: '#808080', i18n: 'product_status.nhap_kho_tq' },
    { value: 2, name: 'Chờ xếp xe', color: '#0051a2', i18n: 'product_status.cho_xep_xe' },
    { value: 3, name: 'Xếp xe TQ', color: '#0051a2', i18n: 'product_status.xep_xe' },
    // { value: 4, name: 'Chờ thông quan TQ', color: '#2d8659', i18n: 'product_status.cho_thong_quan_tq' },
    { value: 5, name: 'Kiểm hóa', color: '#2d8659', i18n: 'product_status.kiem_hoa' },
    { value: 6, name: 'Chờ thông quan VN', color: '#2d8659', i18n: 'product_status.cho_thong_quan_vn' },
    { value: 7, name: 'Nhập kho VN', color: '#FFB74D', i18n: 'product_status.nhap_kho_vn' },
    { value: 8, name: 'Xuất thiếu', color: '#2d8659', i18n: 'product_status.xuat_thieu' },
    { value: 9, name: 'Xuất đủ', color: '#0059b3', i18n: 'product_status.xuat_du' },
  ],
  BILL_STATUS: {
    chua_xuat: 1,
    da_xuat: 2,
    da_thanh_toan: 3,
  },
  BILL_STATUS_LIST: [
    { value: 1, name: 'Chưa xuất', color: '#0059b3', i18n: 'bill_status.chua_xuat' },
    { value: 2, name: 'Đã xuất', color: '#FFB74D', i18n: 'bill_status.da_xuat' },
    { value: 3, name: 'Đã thanh toán', color: '#2d8659', i18n: 'bill_status.da_thanh_toan' },
  ],
  PRICE_TYPE_LIST: [
    { value: 0, name: 'Tự động', i18n: 'price_type.tu_dong' },
    { value: 1, name: 'Theo cân', i18n: 'price_type.theo_can' },
    { value: 2, name: 'Theo khối', i18n: 'price_type.theo_khoi' }
  ],
  FEE_CNY_LIST: [
    { value: 1, name: 'Ship nội địa' },
    { value: 2, name: 'Phí nâng hàng' },
    { value: 3, name: 'Phí hạ hàng' },
    { value: 4, name: 'Phí kéo hàng' },
    { value: 5, name: 'Phí gia cố' },
    { value: 6, name: 'Phí đóng gỗ' },
    { value: 7, name: 'Phí kiểm đếm' },
    { value: 8, name: 'Phí lưu kho' },
    { value: 9, name: 'Phí cân' },
    { value: 10, name: 'Phí kiểm tra chất lượng' },
    { value: 11, name: 'Phí tự công bố' },
    { value: 12, name: 'Phí xử lý hải quan' },
    { value: 13, name: 'Phí thương kiểm' },
    { value: 14, name: 'Thuế NK' },
    { value: 15, name: 'Thuế VAT' },
    { value: 16, name: 'Phí ủy thác' },
    { value: 17, name: 'Phí khai báo mã hàng' },
    { value: 18, name: 'Cước giao tận nơi' },
    { value: 99, name: 'Phí khác' }
  ],
  TRUCK_CALLER: [
    { value: '', name: '' },
    { value: 'bich_thuy', name: 'Bích Thủy' },
    { value: 'trung_dung', name: 'Trung Dũng' },
    { value: 'dung_than_tsl', name: 'Dũng Thân (TSL)' },
  ]
};